import React, {Component} from "react";
import CanvasModel from "./CanvasModel";
import textures from "../externalData/textures";
import TexturesCollection from "./TexturesCollection";
import ModelsCollection from "./ModelsCollection";
import AllControlsContainer from "./AllControlsContainer";
import {DragDropContext} from 'react-beautiful-dnd';
import DescriptionTexts from "./DescriptionTexts";
import Constants from "./Constants";
import {withTranslation} from "react-i18next";

class MainComponent extends Component{
    constructor(props) {
        super(props);
        // Retrieve shown sofaId from storage
        let isLocalHost = false;
        let shownModelID;

        if(Constants.HOST_WEBSITE === 'ddn'){
            shownModelID = Boolean(!isLocalHost) ? JSON.parse(localStorage.getItem('sofaId')) : 1;
        } else if (Constants.HOST_WEBSITE === '3d-sofa'){
            shownModelID = this.props.models.find(item => item.isShown === 'true').id;
        }
        if(isNaN(shownModelID)){
            alert("Ошибка загрузки данных");
        }

        this.state = {
            selectedTextureId : textures[0].id,
            selectedModelId : shownModelID,
            isTextureDragging : false,
            draggedTextureId : -1,
            isModelTwistingComplete: false,
        };
        this.canvasModelRef = React.createRef();
    }

    componentDidMount() {
        this.resetDimensions();
    }

    resetDimensions = (e) => {
        let canvasContainer = document.getElementById('canvasContainer');
        const width = parseInt(canvasContainer.clientWidth);
        const height = parseInt(width / Constants.DIMMENSIONS_RATIO);//parseInt(getComputedStyle(this.mount).height) - 2;

        this.setDocumentVariable('--sizeW', width + 'px');
        this.setDocumentVariable('--sizeH', height + 'px');
    };

    setState = (newState) => {
        const { state } = this;
        console.log('prevState ', state);
        console.log('newState ', newState);
        super.setState(newState);
    };

    setDocumentVariable = (propertyName, value) => {
        document.documentElement.style.setProperty(propertyName, value);
    };

    onTwistingComplete = () => {
        this.setState({isModelTwistingComplete : true});
    };

    onTextureClick = (clickedItem) => {
        this.setState({
            selectedTextureId : clickedItem.id
        })
    };

    onModelClick = (clickedModel) => {
        if(this.state.isModelTwistingComplete){
            this.setState({
                selectedModelId : clickedModel.id
            })
        }
    };

    onZoomClick = (e) => {
        this.canvasModelRef.current.onZoomClick(e);
    };

    onDragStart = (result) => {
        this.canvasModelRef.current.setDraggableId(result.draggableId);
        this.setState({
            isTextureDragging : true,
        });
        document.getElementsByClassName('textureItemContainer').position = 'absolute';
    };

    onDragUpdate = (result) => {
        console.log('onDragUpdate');
    };

    onDragEnd = (result) => {
        console.log('onDragEnd : ' + result.source.index);

        this.canvasModelRef.current.setDraggableId(result.draggableId);
        this.setState({
            isTextureDragging : false
        })
    };

    onImageIsLoaded = () => {
        this.canvasModelRef.current.onBgImageIsLoaded();
    };

    onSendFeedbackClick = (state) => {
        const { t } = this.props;
        this.canvasModelRef.current.saveScreenShot(state, t('FORM_SUCCESS_DESCRIPTION'));
    };

    onAnimationClick = (isDirectionForward) => {
        this.canvasModelRef.current.startAnimation(isDirectionForward);
    };

    render() {
        let selectedModel = this.props.models.find(item => item.id === this.state.selectedModelId);

        return (
            <div id='rootContainer'
                 className='p-0'>
                <div className='screenshotDiv'/>
                <ModelsCollection
                    models={this.props.models}
                    onModelClick={this.onModelClick}
                />
                <div id="wrapperContainer" className='wrapperContainer row mx-auto'>
                    <DragDropContext
                        onDragStart={this.onDragStart}
                        onDragUpdate={this.onDragUpdate}
                        onDragEnd={this.onDragEnd}
                    >
                        <AllControlsContainer
                            onClick={this.onZoomClick}
                            onImageIsLoaded={this.onImageIsLoaded}
                            onSendFeedbackClick={this.onSendFeedbackClick}
                            onAnimationClick={this.onAnimationClick}
                        />
                        {this.state.selectedModelId ? (
                        <CanvasModel
                            ref={this.canvasModelRef}
                            selectedModel={selectedModel}
                            textureId={this.state.selectedTextureId}
                            isTextureDragging={this.state.isTextureDragging}
                            onTwistingComplete={this.onTwistingComplete}
                            translation={this.props.t}
                        />) : null}
                        <DescriptionTexts/>
                        <TexturesCollection
                            textures={textures}
                            onTextureClick={this.onTextureClick}
                            droppableId="textures"
                        />
                    </DragDropContext>
                </div>
            </div>
        )
    }
}
export default withTranslation('common')(MainComponent);
